import React from 'react';
import './common.css';

/**
 * LoadingSpinner
 *
 * Props:
 *   size    — 'sm' | 'md' (default) | 'lg'
 *   label   — optional text below spinner
 *   fullPage — centers in min-height:60vh block
 */
const LoadingSpinner = ({ size = 'md', label, fullPage = false }) => {
  return (
    <div className={`spinner-wrapper ${fullPage ? 'spinner-fullpage' : ''}`}>
      <div className={`spinner spinner-${size}`} aria-label="Loading" role="status" />
      {label && <p className="spinner-label">{label}</p>}
    </div>
  );
};

export default LoadingSpinner;
